<template>
  <div class="payment-page mt-5">
    <h1>Choose Your Subscription Plan</h1>
    <div class="plans mt-5">
      <div class="plan" v-for="plan in plans" :key="plan.id">
        <h2>{{ plan.name }}</h2>
        <p>{{ plan.details }}</p>
        <div v-if="plan.constraints">
          <v-simple-table dense>
            <tbody>
              <tr>
                <td>Advance Searches</td>
                <td>{{ plan.constraints.max_advance_search }}</td>
              </tr>
              <tr>
                <td>Full Views</td>
                <td>{{ plan.constraints.max_full_view }}</td>
              </tr>
              <tr>
                <td>Report Downloads</td>
                <td>{{ plan.constraints.max_report_download }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
        <p class="cost">{{ plan.cost }}</p>
        <v-btn @click="selectPlan(plan)" color="primary">Select Plan</v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator"
import plansData from "@/assets/plans/plans.json"

@Component
export default class PaymentPage extends Vue {
  plans = plansData.plans

  selectPlan(plan) {
    let planId = plan.id
    this.$router.push({name: "checkout", params: {planId: planId}})
  }
}
</script>

<style scoped>
.payment-page {
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.plans {
  display: flex;
  justify-content: space-around;
}

.plan {
  border: 1px solid #ccc;
  padding: 20px;
  width: 30%;
}

.plan img {
  max-width: 100%;
  height: auto;
}

.cost {
  font-weight: bold;
  margin: 10px 0;
}
</style>
